__turbopack_context__.v({
  "copyItem": "styles-module__93OFhG__copyItem",
  "featureOverlay": "styles-module__93OFhG__featureOverlay",
  "imageMotion": "styles-module__93OFhG__imageMotion",
  "parallaxMedia": "styles-module__93OFhG__parallaxMedia",
  "parallaxStage": "styles-module__93OFhG__parallaxStage",
  "primaryImageLayer": "styles-module__93OFhG__primaryImageLayer",
  "roundedClip": "styles-module__93OFhG__roundedClip",
  "secondaryImageLayer": "styles-module__93OFhG__secondaryImageLayer",
});
